"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finleyStringify = void 0;
const error_1 = require("../error");
const validStrinfigyTypes = [
    // native support
    'boolean',
    'number',
    'string',
    'null',
    'object',
    'array',
    // extended types
    'bigint',
];
/**
 * Custom JSON stringify method that extends stringify support to types not supported by `JSON.stringify`. Currently extends support to:
 *
 * - `BigInt`
 */
const finleyStringify = (obj) => {
    return JSON.stringify(obj, (_, value) => {
        (0, error_1.finleyAssert)(validStrinfigyTypes.includes(typeof value), `Attempted to finleyStringify unsupported type [${typeof value}]`);
        if (typeof value === 'bigint') {
            return `${value.toString()}n`; // Append 'n' to distinguish BigInt
        }
        return value;
    });
};
exports.finleyStringify = finleyStringify;
//# sourceMappingURL=index.js.map